function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import EditAgreementModal from "../components/EditAgreementModal/EditAgreementModal";
import { useOverlayContext, useStoreActions } from "../contexts";
import { handleRequest } from "../infra/utils";
const loader = 'getRelationship';
export function useOpenEditAgreementModal() {
  const {
    api,
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  async function getRelationship(options) {
    if (options.relationship) {
      return options.relationship;
    } else {
      overlayContext.startLoader(loader);
      const relationship = await handleRequest(api.relationship.get(options.relationshipId, {
        // We need paymentMethod info for the edit-agreement modal.
        resolvePaymentMethod: true
      }));
      overlayContext.stopLoader(loader);
      return relationship.data;
    }
  }
  return async options => {
    const relationship = await getRelationship(options);
    if (relationship) {
      logBI(11000);
      return overlayContext.showModal({
        content: props => /*#__PURE__*/React.createElement(EditAgreementModal, _extends({}, props, {
          relationship: relationship,
          onUpdate: options.onUpdate
        }))
      });
    }
  };
}